import { useState } from 'react';

import QuickbookDesktopSettings from 'containers/Integrations/QuickbookDesktop/Settings';
import QuickbookDesktopSetup from 'containers/Integrations/QuickbookDesktop/Setup';
import { useIntegrationStore } from 'store/useIntegrationStore';

const Configuration = () => {
  const integrationListData: any = useIntegrationStore(state => state.integrationList);

  const quickbookDesktopIntegrationData = integrationListData.filter(
    (tab: any) => tab.key === 'quick-books-desktop'
  )[0];

  const [isConnected, setConnected] = useState<boolean>(quickbookDesktopIntegrationData.is_connected);

  return (
    <>
      {isConnected ? (
        <QuickbookDesktopSettings onDisconnect={() => setConnected(false)} />
      ) : (
        <QuickbookDesktopSetup onConnected={() => setConnected(true)} />
      )}
    </>
  );
};
export default Configuration;
